import { render, staticRenderFns } from "./modalBobinas.vue?vue&type=template&id=6edd94c8&"
import script from "./modalBobinas.vue?vue&type=script&lang=js&"
export * from "./modalBobinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports